// removed by extract-text-webpack-plugin
module.exports = {"loader":"loader","loader-container":"loader-container","loader-content":"loader-content","loading-indicator":"loading-indicator","loading-indicator-spinner":"loading-indicator-spinner","rotate":"rotate","visible":"visible","overlay":"overlay","fit":"fit"};


//////////////////
// WEBPACK FOOTER
// ./src/common/component/loader/loader.style.sass
// module id = NnTa
// module chunks = 3